import {Button, Col, Image, Row} from "antd"
import React, {useEffect, useState} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {IEvent} from "../../model/event.model"
import {closeEvent, getEvent, openEvent} from "../../service/event.service"
import {useDispatch, useSelector} from "react-redux"
import {pageLoadingSActions} from "../../common/store/page-loading.state"
import {formatterDate} from "../../common/date.formatter"
import {RootState} from "../../common/store";

export const EventDetailPage = () => {
    const [isLogged, isAdmin] = useSelector((state: RootState) => {
        return [state.login.isLogged, state.login.isAdmin]
    })

    const [event, setEvent] = useState<IEvent>({} as IEvent)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const params = useParams()

    useEffect(() => {
        refreshPage()
    }, [params.eventId])

    const navigateTo = () => {
        navigate(`/event/${event.id}/new-subscription`)
    }

    const backToHome = () => {
        navigate('/')
    }

    const onCloseEvent = () => {
        closeEvent(event.id).subscribe(() => refreshPage())
    }

    const onOpenEvent = () => {
        openEvent(event.id).subscribe(() => refreshPage())
    }

    const refreshPage = () => {
        dispatch(pageLoadingSActions.showLoading())
        getEvent(params.eventId!).subscribe(value => {
            setEvent(value)
            dispatch(pageLoadingSActions.hideLoading())
        })
    }

    return (
        <Row style={{textAlign: "center"}}>
            {event.id && <>
                <Col span={24}>
                    <h1 style={{
                        textAlign: "center",
                        fontSize: "30px",
                        marginBottom: "30px"
                    }}>{formatterDate(event.date)} - {event.description}</h1>
                </Col>
                <Col span={24}>
                    <h2>{event.active ? 'Iscrizioni aperte' : 'Iscrizioni chiuse'}</h2>
                </Col>
                <Col span={24}>
                    <div className="detail buttons-container" style={{justifyContent: "center"}}>
                        <Button type="default" onClick={backToHome}>
                            Indietro
                        </Button>
                        {event.active ? <Button type="primary" onClick={navigateTo}>
                            Iscrizioni online
                        </Button> : <></>
                        }
                        {isLogged && isAdmin && <> {
                            event.active ?
                                <Button type="primary" onClick={onCloseEvent}>
                                    Chiudi Gara
                                </Button>
                                :
                                <Button type="primary" onClick={onOpenEvent}>
                                    Apri Gara
                                </Button>
                        }
                        </>
                        }
                    </div>
                    <Image
                        style={{maxWidth: "800px"}}
                        src={event.bigUrl}
                    />
                </Col>
            </>
            }
        </Row>
    )
}